import { render } from "./Register_2.vue?vue&type=template&id=225e117b&scoped=true"
import script from "./Register_2.vue?vue&type=script&lang=js"
export * from "./Register_2.vue?vue&type=script&lang=js"

import "./Register_2.vue?vue&type=style&index=0&id=225e117b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\noklo\\Documents\\GitHub\\NontCO2\\NontRegister-market\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225e117b"]])

export default __exports__